import { Address } from './commerce-client';

/**
 * TT-713: Es gibt keine Benutzerkonten mehr, nur noch Gastbestellungen.
 * Übrig bleiben der Profiltyp und der Feldfilter, die beide von der
 * Gast-Checkout-Strecke gebraucht werden (AddressPage, OrderDetailPage).
 *
 * Entfernt wurden die kontogebundenen Funktionen getCurrentUser,
 * getCurrentUserProfile, updateCurrentUserProfile und deleteUser.
 */
export type Profile = {
  address: {
    langcode: String;
    country_code: String;
    locality: String;
    postal_code: String;
    address_line1: String;
    given_name: String;
    family_name: String;
  };
  field_salutation: String;
  field_title: String;
  field_email: String;
  field_date_of_birth: String;
  field_phone_number: String;
  field_address_type: String;
};

// Removes all fields which are not needed for the form.
export function filterCustomerProfile(unfilteredProfile) {
  const customerProfile = (({
    address,
    field_date_of_birth,
    field_email,
    field_phone_number,
    field_salutation,
    field_title,
  }) => ({
    address,
    field_date_of_birth,
    field_email,
    field_phone_number,
    field_salutation,
    field_title,
  }))(unfilteredProfile) as Address;
  return customerProfile;
}
